<template>
  <vs-row vs-type="flex" vs-w="12">
    <vs-row id="branchReportHeaderChips" vs-type="flex" vs-w="12" class="mt-4" vs-align="center"
            vs-justify="space-between">
      <vs-col vs-type="flex" vs-sm="12" vs-w="5.9"
              class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto" vs-align="center">
            <vs-button size="large" radius icon-pack="pickicon" class="giroChip" color="transparent" icon="icon-rich"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#51C2C2;">
                  {{ totalsOfSales.totalAmount ? $convertCurrency(totalsOfSales.totalAmount) : "₺0,00" }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">
                  {{ (selectedTimeRange ? selectedTimeRange : '') + ' Kazanılan Ciro' }}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-sm="12" vs-w="5.9"
              class="bg-white py-3 px-2 my-1 sale-box-shadow low-border-radius">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="w-auto" vs-align="center">
            <vs-button size="large" class="quantityChip" radius icon-pack="pickicon" icon="icon-products"
                       color="transparent"/>
          </vs-col>
          <vs-col vs-type="flex" vs-w="9" class="pl-2" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-medium-small2 bold" style="color:#FF3D67;">
                  {{ totalsOfSales.totalPiece ? (totalsOfSales.totalPiece.toLocaleString() + ' Adet') : "0 Adet" }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-secondary text-xsmall weight-600">
                  {{ (selectedTimeRange ? selectedTimeRange : '') + ' Yapılan Satış Sayısı' }}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row id="branchReportContent" vs-type="flex" vs-w="12"
            class="mt-4 bg-white px-2 pt-4 sale-box-shadow low-border-radius">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col id="branchReportDonutChart" vs-type="flex" vs-sm="12" vs-md="5" vs-lg="5" vs-align="center"
                  class="my-1">
            <vs-row vs-type="flex" vs-w="12" vs-align="center">
              <vs-row vs-type="flex" vs-w="12" id="branchReportDonutChartHeader">
                <span class="w-full px-1 text-center text-xsmall text-secondary bold">
                  {{ (selectedTimeRange ? selectedTimeRange : '') + ' Kazanılan Toplam Ciro' }}
                </span>
                <span class="text-primary w-full text-center bold text-large-medium">
                  {{ $convertCurrency(getSumOfPayments()) }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" vs-justify="center" id="branchReportDonutChartContent">
                <apexchart v-if="payments" type="donut" height="420" :options="getChartOptions"
                           :series="getReportDataPayments()">
                </apexchart>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col id="branchReportList" vs-type="flex" vs-md="7" vs-lg="7" vs-sm="12" class="my-1">
            <vs-row vs-type="block" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="w-full text-secondary bold text-xsmall">
                  {{ isBranchesOrPersonal == true ? 'Şube Sıralaması' : 'Personel Sıralaması' }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12" v-if="(isBranchesOrPersonal && branchGiros) || (!isBranchesOrPersonal && personalGiros != null)">
                <vs-row id="branchReportListRow" vs-type="flex" vs-w="12" class="border-bottom"
                        v-for="(branch,index) in (isBranchesOrPersonal == true ? branchGiros.filter(x=> x.totalPrice > 0) : personalGiros.filter(x=> x.totalPrice > 0))"
                        :key="index">
                  <vs-col vs-type="flex" vs-w="5" vs-align="center">
                    <span class="text-primary mr-2"
                          :class="{'text-smaller weight-600' : index != 0, 'text-medium bold' : index == 0}">
                      {{ (index + 1) + '.' }}
                    </span>
                    <span class="text-primary"
                          :class="{'text-smaller weight-600' : index != 0, 'text-medium-small bold' : index == 0}">
                      {{ isBranchesOrPersonal ? branch.branch.name : branch.userInfo.name }}
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="3" vs-align="center">
                    <span class="text-secondary weight-600 text-xsmall w-full text-center">
                      {{ orderBy == 0 ? (branch.productQuantity.toLocaleString() + ' Adet') : $convertCurrency(branch.totalPrice) }}
                    </span>
                  </vs-col>
                  <vs-col vs-type="flex" vs-w="4" vs-align="center">
                    <span class="text-primary weight-600 text-smaller w-full text-center">
                      {{ orderBy == 1 ? (branch.productQuantity.toLocaleString() + ' Adet') : $convertCurrency(branch.totalPrice) }}
                    </span>
                  </vs-col>
                </vs-row>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="py-2" vs-justify="center" vs-align="center" v-if="!stop">
          <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
            Detay Sayfasına Git
          </span>
        </vs-row>
      </vs-row>
    </vs-row>
  </vs-row>
</template>

<script>
export default {
  name: "branch-or-personal-giro-min",
  components: {
    BranchOrPersonalGiro: () => import("./BranchOrPersonalGiro.vue")
  },
  props: {
    stop: {
      required: true,
      type: Boolean
    },
    payments: {
      required: true,
      type: Array
    },
    branchGiros: {
      required: false,
      type: Array
    },
    personalGiros: {
      required: false,
      type: Array
    },
    totalsOfSales: {
      required: true,
      type: Object
    },
    orderBy: {
      required: true,
      type: Number
    },
    selectedTimeRange: {
      required: true,
      type: String
    },
    isBranchesOrPersonal: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      themeColors: ['#FF3D67', '#FF9F40', '#4BC0C0', '#FFCD56', '#36A2EB', '#1a1a2e', '#8d93ab', '#ec0101',
        '#fbe2e5'
      ],
    }
  },
  computed: {
    getChartOptions() {
      return {
        chart: {
          width: '100%'
        },
        tooltip: {
          y: {
            formatter: function (val) {
              var formatter = new Intl.NumberFormat('tr-TR', {
                style: 'currency',
                currency: 'TRY',
              });
              return formatter.format(val);
            }
          },
          enabled: false
        },
        plotOptions: {
          pie: {
            donut: {
              size: '75%',
              labels: {
                show: true,
                name: {
                  show: true
                },
                value: {
                  show: true,
                  formatter: function (val) {
                    var formatter = new Intl.NumberFormat('tr-TR', {
                      style: 'currency',
                      currency: 'TRY',
                    });
                    return formatter.format(val);
                  }
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.payments.map(x => x.name.toString()),
        colors: this.themeColors,
        legend: {
          floating: false,
          position: 'bottom',
          maxHeight: 200,
          fontSize: '13px',
          fontWeight: 500,
          itemMargin: {
            vertical: 3,
            horizontal: 5
          },
          formatter: function (seriesName, opts) {
            var formatter = new Intl.NumberFormat('tr-TR', {
              style: 'currency',
              currency: 'TRY',
            });
            return [seriesName, " - ", formatter.format(opts.w.globals.series[opts.seriesIndex])]
          }
        }
      };
    },
  },
  methods: {
    getReportDataPayments() {
      return this.payments.map(x => x.value);
    },
    getSumOfPayments() {
      return this.payments.reduce((x, y) => x + y.value,0);
    },
    openDetailPage() {
      this.$router.push('/pages/reports/branch-report').catch(() => {
      })
    }
  }
}

</script>

<style>
#branchReportHeaderChips i {
  font-weight: bold !important;
}

#branchReportHeaderChips button {
  border-width: revert !important;
}

#branchReportHeaderChips .apexcharts-pie-label,
.apexcharts-datalabels,
.apexcharts-datalabel,
.apexcharts-datalabel-label,
.apexcharts-datalabel-value {
  font-family: inherit !important;
  font-weight: 600 !important;
}

#branchReportListRow {
  margin-top: 9px;
  margin-bottom: 9px;
}

#branchReportList {
  max-height: 60vh;
}

#branchReportList > .vs-row {
  overflow: auto !important;
}

/* Masaüstünde liste, soldaki grafik sütunuyla aynı yükseklikte kalır; şube sayısı artınca kaydırma çıkar */
@media only screen and (min-width: 768px) {
  #branchReportList {
    position: relative;
    align-self: stretch;
    max-height: none;
  }

  #branchReportList > .vs-row {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto !important;
  }
}

#branchReportListRow:first-of-type {
  margin-top: 0 !important;
}

#branchReportListRow:last-of-type {
  margin-bottom: 0 !important;
}

.apexcharts-legend-text {
  font-family: "Montserrat", Helvetica, Arial, sans-serif !important;
  font-size: 13.5px !important;
}

#branchReportHeaderChips .giroChip {
  border: 1px solid rgb(81, 194, 194) !important;
  color: rgb(81, 194, 194) !important;
}

#branchReportHeaderChips .quantityChip {
  border: 1px solid rgb(255, 61, 103) !important;
  color: rgb(255, 61, 103) !important;
}

#branchReportDonutChartContent foreignObject {
  overflow: visible !important;
}

.apexcharts-legend {
  padding: 0 !important;
  max-height: 220px !important;
  overflow-y: auto !important;
}

.apexcharts-legend::-webkit-scrollbar {
  width: 8px;
  background-color: #f5f5f5;
}

.apexcharts-legend::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 10px;
}

.apexcharts-legend::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

</style>
